/**
 * The code in this file was derived from, or influenced by, TerriaJS:
 * https://github.com/TerriaJS/terriajs
 */

import MapService from 'app/shared/utilities/imagery/map_service';

interface WebMapTileServiceLayer {
    name: string;
    layer: string;
}

export default class WebMapTileService extends MapService {
    public static regex = /\/WMTS\b/i;
    public _layers: WebMapTileServiceLayer[];

    constructor(url: string, fetch?) {
        super(url, fetch);

        this._layers = [];
    }

    hasOptionalParameter(key: string) {
        return !!this.optionalParameters[key];
    }

    getOptionalParameter(key: string) {
        return this.optionalParameters[key];
    }

    load(): Promise<void> {
        this._hasDataError = false;
        const { baseUrl, query } = this.cleanAndProxyUrl(this._url);
        query.set('request', 'GetCapabilities');
        const capabilitiesUrl = baseUrl + '?' + query.toString();

        return this._fetch(capabilitiesUrl)
            .then((response) => response.text())
            .then((xml) => {
                const json = this.convertXmlToJson(xml);

                // Make sure we actually have capabilities data
                if (!json.Capabilities) {
                    throw new Error('Unable to load xml');
                }

                return json.Capabilities;
            })
            .then((json) => {
                // WMTS does not have layer hierarchy like WMS.  Instead, it has a separate/optional Themes section that
                // groups layers by reference.  We currently don't support the Themes section.
                let layers;
                if (!json.Contents || !json.Contents.Layer) {
                    layers = [];
                } else if (Array.isArray(json.Contents.Layer)) {
                    layers = json.Contents.Layer;
                } else {
                    layers = [json.Contents.Layer];
                }

                layers.forEach((layer) => {
                    if (layer.Title) {
                        this._layers.push({
                            name: layer.Title,
                            layer: layer.Identifier,
                        });
                    } else if (layer['ows:Title']) {
                        this._layers.push({
                            name: layer['ows:Title'],
                            layer: layer['ows:Identifier'],
                        });
                    }
                });
            })
            .catch((error) => {
                this._hasDataError = true;
                console.error(error);
            });
    }
}
